import { EventBus } from '@/event-bus';
export default {
    name: 'Logon',
    data: () => {
        return {
            loading: false,
            errors: '',
            credentials: {}
        }
    },
    created() {
        var model = this;

        if (this.$route.query.new) {
            this.credentials.userName = this.$route.query.userName;

            toast({
                title: 'Felicitari',
                message: 'Noua ta parola a fost inregistrata. De acum o poti folosi pentru a intra in aplicatie.',
                type: 'success',
                timeout: 10000
            });
        }
    },
    computed: {
    },
    methods: {
        handleSubmit() {
            this.loading = true;

            this.$store.dispatch('auth/authRequest', this.credentials)
                .then((result) => {
                    EventBus.$emit('logon_completed');
                })
                .catch((err) => {
                    // if (err == "undefined")
                    this.errors = 'Nume utilizator sau parolă incorecte!';
                })
                .then(() => {
                    this.loading = false;
                });
        },
        forgotPasswordClick() {
            this.$router.push('/forgotPassword');
        }
    }
}
